import { RootState } from 'packages/blu-booking/src/store';
import { memo, useDeferredValue, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Scheduler } from './UI/Scheduler';
import { CalendarLoader } from '../../UI/CalendarLoader/CalendarLoader';
import { usePointOfSaleHoursCalendar } from 'packages/blu-booking/src/data_fetching/PointOfSaleHours/PointOfSaleHoursCalendar';
import { usePointOfSaleHoursShift } from 'packages/blu-booking/src/data_fetching/PointOfSaleHours/PointOfSaleHoursShift';
import { Stack } from '@mui/material';

export const CalendarDefaultInner = memo(
  function CalendarDefaultInner(): JSX.Element {
    const { filtersLoad } = useSelector(
      (state: RootState) => state.bluBookingCalendarFilters
    );

    const { selectedDate, view, selectedPointOfSale, selectedUsers } =
      useSelector((state: RootState) => state.bluBookingDefaultCalendar);

    const { data: calendar, isLoading: isLoadingCalendarPointOfSale } =
      usePointOfSaleHoursCalendar({
        selectedDate,
        view,
        pointOfSaleId: selectedPointOfSale?.id,
        selectedUsers,
        options: {
          enabled: filtersLoad ?? false,
          refetchInterval: 300000,
        },
      });

    const { data: shift, isLoading: isLoadingShiftPointOfSale } =
      usePointOfSaleHoursShift({
        selectedDate,
        view,
        pointOfSaleId: selectedPointOfSale?.id,
        selectedUsers,
        options: {
          enabled: filtersLoad ?? false,
          refetchInterval: 300000,
        },
      });

    const calendarPointOfSale = useDeferredValue(calendar);
    const shiftPointOfSale = useDeferredValue(shift);

    const GetContent = useMemo(() => {
      if (isLoadingCalendarPointOfSale || isLoadingShiftPointOfSale)
        return (
          <Stack
            alignItems="center"
            justifyContent="center"
            direction="row"
            flex="1"
            sx={{
              height: '100%',
              width: '100%',
              backgroundColor: 'var(--base-foreground-color) ',
            }}
          />
        );
      return (
        <Scheduler
          calendarPointOfSale={calendarPointOfSale}
          shiftPointOfSale={shiftPointOfSale}
        />
      );
    }, [
      isLoadingCalendarPointOfSale,
      isLoadingShiftPointOfSale,
      calendarPointOfSale,
      shiftPointOfSale,
    ]);

    return (
      <div key="Default" style={{ height: '100%' }}>
        {GetContent}
        <CalendarLoader
          open={isLoadingCalendarPointOfSale || isLoadingShiftPointOfSale}
        />
      </div>
    );
  }
);
